import { render, staticRenderFns } from "./PhdProposalCp.vue?vue&type=template&id=45075d70&scoped=true&"
import script from "./PhdProposalCp.vue?vue&type=script&lang=js&"
export * from "./PhdProposalCp.vue?vue&type=script&lang=js&"
import style0 from "./PhdProposalCp.vue?vue&type=style&index=0&id=45075d70&prod&lang=css&"
import style1 from "./PhdProposalCp.vue?vue&type=style&index=1&id=45075d70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45075d70",
  null
  
)

export default component.exports